import * as React from "react"
import PropTypes from "prop-types"

import "./style.less"

import Nav from "./nav"
import Copyright from "./copyright"
import Logo from "../logo"
import Socials from "./socials"

const Footer = ({ routeParams }) => (
  <footer className="flex flex-col">
    <Nav routeParams={routeParams} />
    <div className="relative max-w-screen-reds-2xl w-full m-auto p-8">
      <div className="reds-border--top sm:reds-border--none p-8 sm:p-0 flex w-full sm:w-auto justify-center sm:justify-start xl:absolute xl:-top-32">
        <Logo width="190px" routeParams={routeParams} />
      </div>
      <div className="xl:absolute xl:-top-6">
        <Socials />
      </div>
      <div className="reds-border--top mt-8">
        <Copyright routeParams={routeParams} />
      </div>
    </div>
  </footer>
)

Footer.propTypes = {
  routeParams: PropTypes.object,
}

export default Footer
